<template>
  <div style="padding: 20px; background: rgb(221, 225, 230); border: 1px solid rgb(204, 204, 204)">
    <v-card class="mb-4" v-if="list_access">
      <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
        <div class="col-md-12">
          <div class="col-md-12" style="background: white">
            <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
            <v-divider class="mt-0"></v-divider>

            <div class="row pt-2">
              <div class="col-md-3">
                <v-text-field v-model="filters.date_from" density="comfortable" type="date" name="date_from" label="Desde" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="filters.date_to" density="comfortable" type="date" name="date_to" label="hasta" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacen" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox v-if="!isClient()" v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clients" label="Cliente" autocomplete="off" clearable></v-combobox>
              </div>

              <div class="col-md-12 pt-2 pb-2" style="display: flex; justify-content: end">
                <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
                <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <v-card v-if="list_access">
      <v-card-title>
        <v-row align="center" class="mt-1">
          <v-col>
            <span>{{ page_title }}</span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>

      <!-- v-if="list_access" -->

      <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.creation_date }}</td>
            <td>{{ item.almacen.name }}</td>
            <td>{{ item.client.name }}</td>            
            <td>{{ item.locations_amount }}</td>
            <td>{{ (item.cubication_type != null)?item.cubication_type.name : '-' }}</td>
            <td>{{ item.lpn_amount }}</td>
            <td>{{ formatVolume(item.vol_total) }}</td>
            <td>{{ formatVolume(item.sup_total) }}</td>
            <td>{{ formatVolume(item.cubication_type_vol_total) }}</td>
            <td>{{ formatVolume(item.cubication_type_sup_total) }}</td>

          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { reportsService } from "@/libs/ws/reportsService";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import UserTypeConstant from "@/constants/user_type";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
export default {
  components: {},
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      service: reportsService,
      page_title: "Ocupacion por pallets",
      userTypeConstant: UserTypeConstant,
      user_type: null,
      headers: [
        {
          title: "Fecha",
          align: "left",
          sortable: true,
          value: "creation_date",
          visible: true,
        },
        {
          title: "Almacen",
          align: "left",
          sortable: true,
          value: "almacen.name",
          visible: false,
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          value: "client.name",
          visible: false,
        },
        {
          title: "Cantidad Ubicaciones",
          align: "left",
          sortable: true,
          value: "locations_amount",
          visible: true,
        },
        {
          title: "Tipo de Cubicaje",
          align: "left",
          sortable: true,
          value: "cubication_type.name",
          visible: true,
          visible_for_client: true,
        },
        {
          title: "Cantidad Pallets",
          align: "left",
          sortable: true,
          value: "lpn_amount",
          visible: true,
        },
        {
          title: "Volumen (m³)",
          align: "left",
          sortable: true,
          value: "vol_total",
          visible: true,
        },
        {
          title: "Superficie (m²)",
          align: "left",
          sortable: true,
          value: "sup_total",
          visible: true,
        },
        {
          title: "Volumen por Tipo de Cubicaje (m³)",
          align: "left",
          sortable: true,
          value: "cubication_type_vol_total",
          visible: true,
        },
        {
          title: "Superficie por Tipo de Cubicaje (m²)",
          align: "left",
          sortable: true,
          value: "cubication_type_sup_total",
          visible: true,
        },
      ],
      filters: {
        date_from: new Date(
          new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        almacen: null,
        client: null,
      },

      almacenes: [],
      clients: [],
    };
  },
  mounted() {
    this.user_type = localStorage.getItem("user_type");
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    //recorro los headers y saco el cliente si el usuario es el cliente
    this.headers = this.headers.filter((header) => {
      if (header.visible_for_client || header.visible_for_client == undefined) {
        return true;
      }
      return !this.isClient();
    });

    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
    this.loadAlmacenes();
    this.loadClientes();
  },
  methods: {
    loadClientes() {
      if(this.isClient()){
        return;
      }
      
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.loadClientes error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.loadAlmacenes error");
          console.log(e);
        });
    },
    getFilterParams() {
      return this.filters;
    },
    loadList(service, param = null) {
      //this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      reportsService
        .ocupacion(param)
        .then((response) => {
          //this.setHeader();
          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.ocupacion error");
          console.log(e);
          this.loading = false;
        });
    },
    filter() {
      this.loadList(this.service, this.filters);
    },
    formatVolume(volume) {
      if (volume === null || volume === undefined) {
        return "0.0000";
      }
      return parseFloat(volume).toFixed(4);
    },
    exportFile() {
      var param = { ...this.getFilterParams() }; // Copia de this.filters
      param["export"] = true;
      this.exportExcel(Constant.SECTION_REPORTS + "/ocupacion", param, "OcupacionPallets.xlsx");
    },
  },
};
</script>
